import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const SITE_URL = "https:// tarjetas.undostres.com.mx";
const DEFAULT_OG = `${SITE_URL}/og-image.png`;

/**
 * Per-route SEO + SEM meta tags.
 * Targets Spanish-language searches (es-MX) and core themes:
 * stablecoins, tarjetas respaldadas, global card issuing, crédito,
 * vales, tarjetas en LatAm, cross-border payments.
 */
const SEO = ({
  title,
  description,
  keywords,
  path = "/",
  image = DEFAULT_OG,
  schema
}) => {
  const { t, i18n } = useTranslation();
  const url = `${SITE_URL}${path}`;
  const lang = (i18n.language || "es").toLowerCase().startsWith("en") ? "en" : "es";
  const ogLocale = lang === "en" ? "en_US" : "es_MX";
  const siteName = t("brand.name");
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={ogLocale} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
